import { ProductsPage } from '@/pages/optimization-group/products'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/_app/p/og/$optimizationGroupId/products'
)({
	component: ProductsPage,
})
